const PRICES = {
	outlander: 2480000,
	outlander_7: false,
	pajero_sport: false,
	pajero4: 3380000,
	x_pander: 2030000,
	eclipse: 2420000,
	l200: 2390000,
	asx: 2220000,
	asxbe: 2082000,
	// asx: false,
	pajero: 2619000,
	outlander_black_edition: 2149000,
};

const ADVANTAGES = {
	outlander: 669000,
	outlander_7: 575100,
	pajero_sport: 1650000,
	pajero4: 970000,
	x_pander: 560000,
	eclipse: 590000,
	l200: 1010000,
	asx: 580000,
	asxbe: 215000,
	pajero: 500000,
	outlander_black_edition: 850000,
};

const PAYMENTS = {
	outlander: 6190,
	outlander_7: 6190,
	pajero_sport: 5307,
	eclipse: false,
	pajero4: false,
	x_pander: false,
	l200: 8690,
	asx: 4931,
	asxbe: 5307,
	pajero: 6500,
	outlander_black_edition: 5307,
};

const BALANCE = {
	outlander: 27,
	outlander_7: 9,
	pajero_sport: 5,
	eclipse: 7,
	pajero4: 5,
	x_pander: 4,
	l200: 9,
	asx: 25,
	asxbe: 7,
	pajero: 1,
	outlander_black_edition: 6,
};

const BONUS = {
	outlander: false,
	outlander_7: false,
	pajero_sport: false,
	eclipse: "credit",
	pajero4: false,
	x_pander: false,
	l200: false,
	asx: "credit",
	asxbe: "credit",
	pajero: false,
	outlander_black_edition: "credit",
};

const LABEL = {
	pajero_sport: false,
};

export default {
	CARS: [
		{
			id: "outlander", // 4
			name: "Mitsubishi Outlander",
			price: PRICES.outlander,
			payment: PAYMENTS.outlander,
			balance: BALANCE.outlander,
			advantage: ADVANTAGES.outlander,
			bonus: BONUS.outlander,
			profits: {
				advantage: "Выгода до 669 000₽",
				price: "Цена от 2 480 000₽",
				guarantee: "Продленная гарантия 5 лет",
				ico1: "Постановка на учет в подарок",
				// secure: "Зимний пакет + сигнализация с автозапуском",
				ico2: "Третье и пятое ТО в подарок",
				ico3: "Кредит от 5,9%",
			},
			test_drive: true,
		},
		{
			id: "pajero4", // 2
			name: "Mitsubishi Pajero 4",
			price: PRICES.pajero4,
			payment: PAYMENTS.pajero4,
			balance: BALANCE.pajero4,
			advantage: ADVANTAGES.pajero4,
			bonus: BONUS.pajero4,
			profits: {
				advantage: "Выгода до 900 000₽",
				price: "Цена от 3 500 000₽",
				guarantee: "Продленная гарантия 5 лет",
				ico1: "Постановка на учет в подарок",
				// secure: "Зимний пакет + сигнализация с автозапуском",
				ico2: "Третье и пятое ТО в подарок",
				secure: "Легенда снова в продаже",
				ico3: "Кредит от 5,9%",
			},
			test_drive: true,
		},
		{
			// 1
			id: "pajero_sport",
			name: "Дизельный Pajero Sport",
			price: PRICES.pajero_sport,
			payment: PAYMENTS.pajero_sport,
			balance: BALANCE.pajero_sport,
			advantage: ADVANTAGES.pajero_sport,
			bonus: BONUS.pajero_sport,
			label: LABEL.pajero_sport,
			profits: {
				advantage: "Выгода до 800 000₽",
				price: "Цена от 4 900 000₽",
				guarantee: "Гарантия 100 000 км.",
				ico1: "Постановка на учет в подарок",
				// secure: "Зимний пакет + сигнализация с автозапуском",
				ico2: "Третье и пятое ТО в подарок",
				ico3: "Рассрочка 0%",
			},
			test_drive: true,
		},
		{
			id: "l200", // 5
			name: "Mitsubishi L200",
			price: PRICES.l200,
			payment: PAYMENTS.l200,
			balance: BALANCE.l200,
			advantage: ADVANTAGES.l200,
			bonus: BONUS.l200,
			profits: {
				advantage: "Выгода до 500 000₽",
				price: "Цена от 3 000 000₽",
				guarantee: "Продленная гарантия 5 лет",
				ico1: "Постановка на учет в подарок",
				// secure: "Зимний пакет + сигнализация с автозапуском",
				ico2: "Третье и пятое ТО в подарок",
				ico3: "Кредит от 5,9%",
			},
			test_drive: true,
		},
		{
			id: "x_pander", // 3
			name: "Mitsubishi X-pander",
			price: PRICES.x_pander,
			payment: PAYMENTS.x_pander,
			balance: BALANCE.x_pander,
			advantage: ADVANTAGES.x_pander,
			bonus: BONUS.x_pander,
			profits: {
				advantage: "Выгода до 560 000₽",
				price: "Цена от 2 030 000₽",
				guarantee: "Гарантия 100 000 км.",
				ico1: "Постановка на учет в подарок",
				// secure: "Зимний пакет + сигнализация с автозапуском",
				ico2: "Третье и пятое ТО в подарок",
				secure: "7 мест",
				ico3: "Кредит от 5,9%",
			},
			test_drive: true,
		},
		// {
		// 	id: "asx", // 6
		// 	name: "Mitsubishi ASX",
		// 	price: PRICES.asx,
		// 	payment: PAYMENTS.asx,
		// 	balance: BALANCE.asx,
		// 	advantage: ADVANTAGES.asx,
		// 	bonus: BONUS.asx,
		// 	profits: {
		// 		advantage: "Выгода до 580 000₽",
		// 		price: "Цена от 2 220 000₽",
		// 		guarantee: "Продленная гарантия 5 лет",
		// 		ico1: "Постановка на учет в подарок",
		// 		// secure: "Зимний пакет + сигнализация с автозапуском",
		// 		ico2: "Третье и пятое ТО в подарок",
		// 		ico3: "Кредит от 5,9%",
		// 	},
		// 	profits_cbf: {
		// 		ico1: "Ключевые особенности нового ASX",
		// 		ico2: "Технические характеристики нового ASX",
		// 		ico3: "Комплектации и цены на новый ASX",
		// 	},
		// },
		// {
		// 	id: "eclipse", // 7
		// 	name: "Mitsubishi Eclipse Cross",
		// 	price: PRICES.eclipse,
		// 	// payment: PAYMENTS.eclipse,
		// 	balance: BALANCE.eclipse,
		// 	advantage: ADVANTAGES.eclipse,
		// 	bonus: BONUS.eclipse,
		// 	profits: {
		// 		advantage: "Выгода до 590 000₽",
		// 		price: "Цена от 2 420 000₽",
		// 		guarantee: "Продленная гарантия 5 лет",
		// 		ico1: "Постановка на учет в подарок",
		// 		// secure: "Зимний пакет + сигнализация с автозапуском",
		// 		ico2: "Третье и пятое ТО в подарок",
		// 		ico3: "Кредит от 5,9%",
		// 	},
		// },
		// {
		//   id: "asxbe",
		//   name: "Mitsubishi ASX BLACK EDITION",
		//   price: PRICES.asxbe,
		//   payment: PAYMENTS.asxbe,
		//   balance: BALANCE.asxbe,
		//   advantage: ADVANTAGES.asxbe,
		//   bonus: BONUS.asxbe,
		//   profits: {
		//     advantage: "Выгода до 1 100 000₽",
		//     guarantee: "Продленная гарантия 5 лет",
		//     ico1: "Постановка на учет в подарок",
		//     secure: "Зимний пакет + сигнализация с автозапуском",
		//     ico2: "Третье и пятое ТО в подарок",
		//     ico3: "Рассрочка 0%",
		//   },
		// },
		// {
		//   id: "outlander_black_edition",
		//   name: "Outlander Black Edition",
		//   price: PRICES.outlander_black_edition,
		//   payment: PAYMENTS.outlander_black_edition,
		//   balance: BALANCE.outlander_black_edition,
		//   advantage: ADVANTAGES.outlander_black_edition,
		//   bonus: BONUS.outlander_black_edition,
		//   profits: {
		//     advantage: "Выгода до 1 100 000₽",
		//     guarantee: 'Продленная гарантия 5 лет',
		//     ico1: "Постановка на учет в подарок",
		//     secure: "Зимний пакет + сигнализация с автозапуском",
		//     ico2: "Третье и пятое ТО в подарок",
		//     ico3: "Рассрочка 0%",
		//   },
		//   test_drive: true,
		// },
	],
};
